import { getCalendarCloudSettingsStore } from '../store/store';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

const DEFAULT_END_LONG_EVENTS_BY_FALLBACK = 10;

/**
 * Gets the effective value for the duration to reduce the long events (one hour or more)
 */
export const getEffectiveEndLongEventsBy = (): number => {
    if (!isMiniFeatureEnabled('mini-cal-speedyMeetingsSetting')) {
        return 0;
    }

    const { endLongEventsBy } = getCalendarCloudSettingsStore();
    return endLongEventsBy ?? DEFAULT_END_LONG_EVENTS_BY_FALLBACK;
};
